import moment from 'moment';
import {
  convertStatus,
  currentMonthTotalValueToReceive,
  getParsedDate,
  getPatientStatus,
  initialDate,
  lastMonthInitialDate,
  previousMonthTotalValueToReceive
} from '../../../utils/Utils';
import { PaymentTypes } from '../../types';

const initialState = {
  subscriptions: [],
  totalAmount: 0,
  activeSubscriptions: 0,
  lastMonthAmount: 0
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PaymentTypes.SAVE_THERAPIST_SUBSCRIPTIONS:
      const totalAmount = currentMonthTotalValueToReceive(payload);

      const lastMonthSubscriptionsValue = previousMonthTotalValueToReceive(payload);

      const subscriptions = payload
        .map(subscription => {
          return {
            patient_name: subscription.patient_name,
            plan: subscription.plan,
            status:
              getPatientStatus(subscription.current_month_payment_status, subscription.plan) ||
              'Sem informação',
            successful_appointments: subscription.successful_appointments,
            nextBillingDate: getParsedDate(subscription.next_billing_date)
          };
        })
        .sort((a, b) => b.status === 'Pago');

      const active = payload.filter(
        item =>
          item.current_month_payment_status === 'Paga' ||
          item.current_month_payment_status === 'A pagar no mês'
      ).length;
      return {
        ...state,
        subscriptions: subscriptions,
        totalAmount,
        activeSubscriptions: active,
        lastMonthAmount: lastMonthSubscriptionsValue
      };
    case PaymentTypes.SAVE_SUBSCRIPTIONS_AMOUNT:
      return { ...state, totalAmount: payload };
    default:
      return state;
  }
};
